import updateDayType from './dayType/updateDayType.js';
import createDayType from './dayType/createDayType.js';
import deleteDayType from './dayType/deleteDayType.js';
import createTour from './tour/createTour.js';
import updateTour from './tour/updateTour.js';
import deleteTour from './tour/deleteTour.js';
import createMeal from './meal/createMeal.js';
import createTourPreReq from './tour/createTourPreReq.js';
import * as createAssignment from './assignment/createAssignment.js';
import * as deleteAssignment from './assignment/deleteAssignment.js';
import * as updateAssignment from './assignment/updateAssignment.js';
import * as deleteJob from './job/deleteJob.js';
import * as updateJob from './job/updateJob.js';
import updateMeal from './meal/updateMeal.js';
import deleteMeal from './meal/deleteMeal.js';
import createTourPayTransaction from './tour/payTransaction/createTourPayTransaction.js';
import updateTourPayTransaction from './tour/payTransaction/updateTourPayTransaction.js';
import deleteTourPayTransaction from './tour/payTransaction/deleteTourPayTransaction.js';
import createTourIndicator from './tour/indicator/createTourIndicator.js';
import updateTourIndicator from './tour/indicator/updateTourIndicator.js';
import deleteTourIndicator from './tour/indicator/deleteTourIndicator.js';
import createTourActivityFlag from './tour/activityFlag/createTourActivityFlag.js';
import updateTourActivityFlag from './tour/activityFlag/updateTourActivityFlag.js';
import deleteTourActivityFlag from './tour/activityFlag/deleteTourActivityFlag.js';

const CRUD = {
  updateDayType,
  createDayType,
  deleteDayType,
  createTour,
  updateTour,
  deleteTour,
  createMeal,
  createTourPreReq,
  createAssignment,
  deleteAssignment,
  updateAssignment,
  deleteJob,
  updateJob,
  updateMeal,
  deleteMeal,
  createTourPayTransaction,
  updateTourPayTransaction,
  deleteTourPayTransaction,
  createTourIndicator,
  updateTourIndicator,
  deleteTourIndicator,
  createTourActivityFlag,
  updateTourActivityFlag,
  deleteTourActivityFlag
};


export default CRUD;
